module.exports = __webpack_public_path__ + "static/media/3graph.8445f6e7.png";